import { formatDateTime, formatDate } from '@/utils/utils'

export default class BidHistory {
  
  get dateCreatedFormatted () {
    return formatDateTime(this.dateCreated)
  }
  get bidLabel () { return BidHistory.formatQuantityPrice(this.quantity, this.price)}
  get counterBidLabel () {return BidHistory.formatQuantityPrice(this.counterQuantity, this.counterPrice)}


  getBidLabel(storageType) {
    //console.log('bid history: ' + JSON.stringify(this))
    let result = this.formatLabel(storageType, this.quantity, this.price, this.city, this.state, this.transferType, this.transferStartDate, this.transferEndDate, this.paymentTerm)
    return result;
  }

  getCounterBidLabel(storageType) {
   // console.log('bid history: ' + JSON.stringify(this))
    let result = this.formatLabel(storageType, this.counterQuantity, this.counterPrice, this.counterCity, this.counterState, this.counterTransferType, this.counterTransferStartDate, this.counterTransferEndDate, this.counterPaymentTerm)
    return result;
  }

  static formatQuantityPrice (quantity, price) {
    return quantity + 'mt @ $' + price + '/mt'
  }

  formatLabel (storageType, quantity, price, city, state, transferType, transferStartDate, transferEndDate, paymentTerm) {
        
    let location = ''
    if(city != null){
      location += ' ' + city 
    } 
    
    if(state !== null){
      location += ' ' + state
    }

    if(location !== ''){
      location = ', ' + location
    }
            
    let paymentTermStr = ''
    if(paymentTerm !== null){
      paymentTermStr = ' - ' + paymentTerm
    }
        
    let transfer = ''
    if(transferStartDate  !== null  && transferEndDate !== null) {
      transfer = transferType === 'DELIVERED' ? ' - Delivered ' : ' - Picked up ';
      transfer += ' between ' + formatDate(transferStartDate) + ' and ' + formatDate(transferEndDate) 
    }
   
    return quantity + 'mt @ $' + price + '/mt ' + transfer + location + paymentTermStr
  }
    
 
  static setClass (obj) {
    if (obj instanceof Object !== true) return
    Object.setPrototypeOf(obj, BidHistory.prototype)
    return obj
  }
  static setClasses (objs) {
    objs.forEach(obj => BidHistory.setClass(obj))
    return objs
  }
}
